import { loadSettings } from "./settingActions";
import {
  register as registerSIP,
  unregister as unregisterSIP,
  getUserAgentOptions,
  updateRegisteredEndpoint,
} from "./sipActions";
import Storage from "../misc/storage";
import * as ActionTypes from "../actions/actionTypes";
import { loginSuccess } from "../actions/configActions";
import { detectLocalIpAddress2 } from "../misc/localIpAddress";
import UserService from "../services/userService";
import MmxApi from "../api/mmxApi";
import UserSession from "../misc/usersession";

export function initUser(user, systemConfig) {
  return (dispatch, getstate) => {
    if (!user && Storage.session.get("user")) {
      user = JSON.parse(Storage.session.get("user"));
    }
    if (!systemConfig && Storage.session.get("systemConfig")) {
      systemConfig = JSON.parse(Storage.session.get("systemConfig"));
    }

    if (systemConfig) {
      dispatch({
        type: ActionTypes.CONFIG_SYSTEM_LOADED,
        payload: {
          systemConfig: systemConfig,
          config: getstate().config,
        },
      });
    }
    if (user) {
      dispatch(loginSuccess(user));
      dispatch(loadSettings());
    }
    if (systemConfig && user) {
      dispatch(
        checkMediaPermissions(getstate().config.mode.audio, getstate().config.mode.video, true, systemConfig, user)
      );
    }
    if (!user && getstate().config.mode.anonymous_autologin) {
      dispatch(login(getstate().config.anonymous.user, getstate().config.anonymous.password));
    }

    dispatch({
      type: ActionTypes.CONFIG_INIT_COMPLETED,
      payload: {},
    });
  };
}

export function checkMediaPermissions(audio, video, collectIfMissing = false, systemConfig, user, saveResult = true) {
  return (dispatch, getstate) => {
    dispatch({
      type: ActionTypes.NETWORK_CLEAR_ALERT,
      payload: { error: "serverError" },
    });

    dispatch({
      type: ActionTypes.NETWORK_CLEAR_ALERT,
      payload: { error: "freeswitchError" },
    });

    dispatch({ type: ActionTypes.SIP_CLEAR_ALERT });

    return new Promise((resolve, reject) => {
      if (getstate().config.webrtc === false && getstate().config.temasys === false) {
        if (saveResult) {
          dispatch({
            type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
            payload: { audio: false, video: false },
          });
        }

        if (systemConfig && user) {
          dispatch(registerSIP(getUserAgentOptions(user, systemConfig, getstate, dispatch)));
        }

        return resolve();
      }

      if (!audio && !video) {
        if (saveResult) {
          dispatch({
            type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
            payload: { audio: false, video: false },
          });
        }
        return resolve();
      }

      if (saveResult) {
        dispatch({
          type: ActionTypes.CONFIG_REQUIREMEDIA_STARTED,
          payload: { audio: false, video: false },
        });
      }

      var availableDevices = { video: false, audio: false };
      var devicesWithGrantedPermissions = { video: false, audio: false };
      var environment = global.window || global;
      environment.navigator.mediaDevices.enumerateDevices().then(function(devices) {
        devices.forEach(function(device) {
          if (video && device.kind === "videoinput") {
            availableDevices.video = true;
            if (device.label !== "") {
              devicesWithGrantedPermissions.video = true;
            }
          }

          if (audio && device.kind === "audioinput") {
            availableDevices.audio = true;
            if (device.label !== "") {
              devicesWithGrantedPermissions.audio = true;
            }
          }
        });

        if (devicesWithGrantedPermissions.audio === audio && devicesWithGrantedPermissions.video === video) {
          if (saveResult) {
            dispatch({
              type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
              payload: {
                audio: audio && devicesWithGrantedPermissions.audio,
                video: video && devicesWithGrantedPermissions.video,
              },
            });
          }
          return resolve();
        }

        // No permissions, but we should't try to get them
        if (!collectIfMissing) {
          if (saveResult) {
            dispatch({
              type: ActionTypes.CONFIG_REQUIREMEDIA_FAILURE,
              payload: {
                audio: devicesWithGrantedPermissions.audio,
                video: devicesWithGrantedPermissions.video,
              },
            });
          }
          return reject();
        }

        const showPermissionOverlay = setTimeout(() => {
          dispatch({
            type: ActionTypes.SHOW_PERMISSIONS_OVERLAY,
          });
        }, 1000);

        // We don't have the required permissions, try to get them...
        var environment = global.window || global;
        environment.navigator.mediaDevices
          .getUserMedia({
            audio: audio && availableDevices.audio,
            video: video && availableDevices.video,
          })
          .then(stream => {
            if (stream) {
              if (stream.stop) {
                stream.stop();
              } else {
                stream.getTracks().forEach(track => {
                  if (track && track.stop) track.stop();
                });
              }
            }

            // We got all the permissions we need!
            if (saveResult) {
              dispatch({
                type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
                payload: {
                  audio: audio && availableDevices.audio,
                  video: video && availableDevices.video,
                },
              });
            }
            resolve();
          })
          .catch(e => {
            if (saveResult) {
              dispatch({
                type: ActionTypes.CONFIG_REQUIREMEDIA_FAILURE,
                payload: {
                  audio: audio && devicesWithGrantedPermissions.audio,
                  video: video && devicesWithGrantedPermissions.video,
                },
              });
            }

            // FIXME NWISE-6132: Find out a good way to show a warning that some calls won't
            //                   work optimally (or at all) since they expect certain media.
            reject(e);

            // let errorMessage = getstate().config.text("error.acquiremedia");

            // switch (e.name) {
            //   case "NotReadableError":
            //   case "AbortError":
            //     errorMessage = getstate().config.text("error.mediaNotReadable");
            //     break;
            //   default:
            //     break;
            // }

            // dispatch({
            //   type: ActionTypes.SIP_ERROR_ALERT,
            //   payload: {
            //     message: errorMessage,
            //   },
            // });

            // reject(e);
          })
          .finally(() => {
            clearTimeout(showPermissionOverlay);
            dispatch({
              type: ActionTypes.HIDE_PERMISSIONS_OVERLAY,
            });
          });
      });
    }).finally(() => {
      detectLocalIpAddress2(
        systemConfig ? systemConfig.SYS_STUN_SERVER_URI : UserSession.getSystemConfig().SYS_STUN_SERVER_URI
      ).then(localIpAddress => {
        dispatch(localIpAquired(localIpAddress));
      });

      if (systemConfig && user) {
        if (getstate().config.browser.isSupported) {
          dispatch(registerSIP(getUserAgentOptions(user, systemConfig, getstate, dispatch)));
        }
      }
    });
  };
}

export function refreshProperties() {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;
    if (securityToken) {
      UserService.getUserProperties(getstate().config.server, securityToken, dispatch)
        .done(data => {
          var properties = {};
          data.propertySet.forEach(function(element) {
            properties[element.key] = element.value;
          }, this);

          var user = {
            ...getstate().user,
            properties: properties,
          };

          Storage.session.set("user", JSON.stringify(user));

          dispatch(initUser());
          dispatch({
            type: "USER_REFRESH",
            payload: { user: user },
          });
        })
        .fail(() => {
          console.warn("Could not get properties for user from server");
        });
    }
  };
}

export function login(username, password) {
  return (dispatch, getstate) => {
    const api = new MmxApi(getstate().config.server, null, dispatch, getstate().network.serverError);
    const params = {
      username: username,
      password: password,
      force: true,
      willUseSipRegistration: true,
    };

    api.user
      .login(params)
      .done(data => {
        var systemConfig = {};
        var properties = {
          sipAddress: data.properties.sipAddress,
        };
        data.properties.propertySet.forEach(function(element) {
          properties[element.key] = element.value;
        }, this);
        data.capabilities.forEach(function(element) {
          systemConfig[element.key] = element.value;
        }, this);

        var user = {
          properties: { ...properties },
          authenticated: true,
          username: username,
          password: password,
          securityToken: data.securityToken,
          uri: data.uri,
          anonymous: getstate().config.anonymous && username === getstate().config.anonymous.user,
        };

        Storage.session.set("user", JSON.stringify(user));
        Storage.session.set("systemConfig", JSON.stringify(systemConfig));
        dispatch(initUser(user, systemConfig));
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        var data = xhr.responseText && xhr.status !== 404 ? JSON.parse(xhr.responseText) : {};
        console.error(xhr);
        console.error("Error when login against " + getstate().config.server + "/userApi/user/api/user/login");

        Storage.session.set("user", null);

        var error = getstate().config.text("error.unknown") + " " + data.errorCode;
        switch (data.errorCode) {
          case -7:
            error = getstate().config.text("error.accountexpired");
            break;
          case -1:
            error = getstate().config.text("error.usernameorpassword");
            break;
          default:
            break;
        }
        dispatch(loginFailed(error, data.errorCode));
      });
  };
}

export function validate1(username, password) {
  return (dispatch, getstate) => {
    var action = {
      type: "USER_LOGINFORM_VALIDATE",
      payload: {
        loginform: {
          usernameValid: username ? true : false,
          passwordValid: password ? true : false,
          valid: username && password,
        },
      },
    };
    dispatch(action);
  };
}

export function logout() {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;
    UserService.logout(getstate().config.server, securityToken, dispatch)
      .done(data => {
        dispatch(logoutSuccess());
        dispatch(unregisterSIP());
        dispatch(updateRegisteredEndpoint(0));
        Storage.session.set("sessionid", null);
        Storage.session.set("user", null);
        Storage.session.set("systemConfig", null);
        Storage.local.set("settings", null);
        localStorage.setItem("logout-event", "logout" + Math.random());
      })
      .fail(() => {
        console.warn("Could not log out from server");
      });
  };
}

export function localLogout() {
  return (dispatch, getstate) => {
    dispatch(logoutSuccess());
    dispatch(unregisterSIP());
    dispatch(updateRegisteredEndpoint(0));
    Storage.session.set("sessionid", null);
    Storage.session.set("user", null);
    Storage.session.set("systemConfig", null);
    Storage.local.set("settings", null);
    localStorage.setItem("logout-event", "logout" + Math.random());
  };
}

export const localIpAquired = localIp => ({
  type: ActionTypes.LOCAL_IP_AQUIRED,
  ip: localIp,
});

function logoutSuccess() {
  return {
    type: ActionTypes.USER_LOGOUT_SUCCESS,
  };
}

function loginFailed(error, errorCode) {
  return {
    type: ActionTypes.USER_LOGIN_FAILED,
    payload: {
      loginerror: error,
      loginerrorCode: errorCode,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js